import { render, staticRenderFns } from "./carers-page.vue?vue&type=template&id=324131ca"
import script from "./carers-page.vue?vue&type=script&lang=js"
export * from "./carers-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports